<template>
  <a @click.prevent="copyContent" class="clipboard-copy-link text-muted">
    <Tooltip label="Copy" linkStyle><i class="far fa-copy" /></Tooltip>
  </a>
</template>


<style scoped>
.clipboard-copy-link:hover {
  color: #808080 !important;
}
</style>



<script>
export default {
  name: 'ClipboardCopyButton',
  props: {
    content: [String, Number]
  },
  methods: {
    async copyContent() {
      try {
        await navigator.clipboard.writeText(this.content || '');

        this.successToast('Text Copied')
      } catch(err) {
        console.error(err)
      }
    }
  }
}
</script>